const manualFrToEn = {
  "Choisissez votre application": "Choose your app",
  "Le bouton ouvre automatiquement le store adapté à votre appareil.": "The button automatically opens the right store for your device.",
  "Choisissez votre appareil": "Choose your device",
  "Sélectionnez votre système pour télécharger l’application.": "Select your system to download the app.",
  "Télécharger sur cet appareil": "Download for this device",
  "Ouverture du store de votre appareil…": "Opening your device’s store…",
  "Ouverture des téléchargements…": "Opening downloads…",
  "Ouvrir le store": "Open the store",
  "Choisir un autre appareil": "Choose another device",
  "Nos applications": "Our apps",
  "Applications": "Apps",
  "Applications WonyaSoft": "WonyaSoft apps",
  "Télécharger WonyaPay et Masomo | WonyaSoft": "Download WonyaPay and Masomo | WonyaSoft",
  "Téléchargez WonyaPay et Masomo sur Android, iPhone, iPad, macOS et Windows depuis leurs stores officiels.":
    "Download WonyaPay and Masomo for Android, iPhone, iPad, macOS and Windows from their official stores.",
  "WonyaPay et Masomo, sur tous vos appareils": "WonyaPay and Masomo, on all your devices",
  "Vos paiements et votre école vous accompagnent. Retrouvez nos applications sur mobile et ordinateur, depuis leurs stores officiels.":
    "Take your payments and school with you. Get our mobile and desktop apps from their official stores.",
  "Choisir mon application": "Choose my app",
  "Gestion scolaire": "School management",
  "Mobile et ordinateur": "Mobile and desktop",
  "Téléchargements": "Downloads",
  "Choisissez votre application et votre appareil": "Choose your app and device",
  "Chaque lien vous mène directement à la fiche officielle de l’application sur le store de votre appareil.":
    "Each link takes you directly to the app’s official listing in your device’s store.",
  "Paiements et gestion de projets": "Payments and project management",
  "Payez, encaissez et retrouvez vos projets, factures et opérations depuis votre téléphone ou votre ordinateur.":
    "Pay, collect payments and access your projects, invoices and transactions from your phone or computer.",
  "Retrouvez les élèves, les classes, les frais scolaires, les présences et les bulletins selon les droits accordés par votre école.":
    "Access students, classes, school fees, attendance and report cards according to the permissions granted by your school.",
  "iPhone et iPad": "iPhone and iPad",
  "Télécharger": "Download",
  "Vos applications à portée de main": "Your apps at your fingertips",
  "Retrouvez WonyaPay et Masomo sur votre téléphone, votre tablette ou votre ordinateur.":
    "Access WonyaPay and Masomo on your phone, tablet or computer.",
  "Voir les téléchargements": "View downloads",
  "Explorer WonyaSoft": "Explore WonyaSoft",
  "Des solutions pour votre quotidien.": "Solutions for your everyday life.",
  "Inscriptions WonyaPay": "WonyaPay registration",
  "Vous êtes une école ou un marchand ?": "Are you a school or a merchant?",
  "Choisissez votre profil pour préparer directement la demande adaptée à votre activité.":
    "Choose your profile to prepare the request that fits your activity.",
  "Inscrire une école": "Register a school",
  "Présentez votre établissement et le parcours de paiement des frais scolaires souhaité.":
    "Tell us about your institution and the school-fee payment journey you need.",
  "Demander l’inscription école": "Request school registration",
  "Inscrire un marchand": "Register a merchant",
  "Présentez votre activité et votre besoin d’encaissement mobile ou de paiement numérique.":
    "Tell us about your business and your mobile collection or digital payment needs.",
  "Demander l’inscription marchand": "Request merchant registration",
  "Demande d’inscription école": "School registration request",
  "Demande d’inscription marchand": "Merchant registration request",
  Accueil: "Home",
  Apropos: "About",
  Connexion: "Login",
  "Découvrir BulkPay": "Discover BulkPay",
  "Consulter la documentation": "Consult the documentation",
  "Pour les développeurs": "For developers",
  "Pour les opérations": "For operations teams",
  "Pour les prestataires de services et les marchands":
    "For service providers and merchants",
  "Thème système": "System theme",
  "Thème clair": "Light theme",
  "Thème sombre": "Dark theme",
  "Thème système. Changer de thème": "System theme. Change theme",
  "Thème clair. Changer de thème": "Light theme. Change theme",
  "Thème sombre. Changer de thème": "Dark theme. Change theme",
  "Une seule intégration pour connecter vos applications aux principaux réseaux Mobile Money en RDC.":
    "One integration to connect your applications to the main Mobile Money networks in the DRC.",
  "Documentation claire et exemples d’intégration":
    "Clear documentation and integration examples",
  "Suivi transactionnel et notifications de statut":
    "Transaction tracking and status notifications",
  "Authentification et échanges sécurisés":
    "Authentication and secure exchanges",
  "Accompagnement jusqu’à la mise en production":
    "Support through to production launch",
  "Préparez, contrôlez et exécutez vos paiements en masse depuis un parcours conçu pour les équipes métier.":
    "Prepare, review, and execute bulk payments through a workflow designed for operations teams.",
  "Import et traitement de listes de paiements":
    "Import and processing of payment lists",
  "Validation des numéros et des montants":
    "Validation of phone numbers and amounts",
  "Historique détaillé de chaque opération":
    "Detailed history of every operation",
  "Suivi centralisé des statuts et des erreurs":
    "Centralized tracking of statuses and errors",
  "Encaissez, transférez et pilotez vos caisses en CDF ou USD depuis une expérience mobile simple.":
    "Collect, transfer, and manage your cash registers in CDF or USD from a simple mobile experience.",
  "Création et gestion de caisses": "Creation and management of cash registers",
  "Encaissement et confirmation instantanée":
    "Collection and instant confirmation",
  "Transfert vers les réseaux Mobile Money":
    "Transfers to Mobile Money networks",
  "QR de collecte et historique des opérations":
    "Collection QR codes and operation history",
  "Documentation API": "API documentation",
  Inscription: "Sign up",
  "Paiement en Masse (BulkPay)": "Bulk payments (BulkPay)",
  "Prêt à Transformer Vos Paiements ?": "Ready to transform your payments?",
  "Sans engagement": "No commitment required",
  "Support 24/7": "24/7 support",
  Tarifs: "Pricing",
  "Tarifs lisibles": "Clear pricing",
  "Voir les Tarifs": "View pricing",
  Solutions: "Solutions",
  "À propos": "About",
  Contact: "Contact",
  "Application WonyaPay": "WonyaPay Application",
  "Menu principal": "Main menu",
  "Ouvrir le menu": "Open menu",
  "Fermer le menu": "Close menu",
  "Navigation mobile": "Mobile navigation",
  "Liens utiles": "Useful links",
  Articles: "Articles",
  Témoignages: "Testimonials",
  "Nos clients": "Our clients",
  Siège: "Head office",
  "Solutions monétiques": "Payment solutions",
  "Processus de paiement": "Payment process",
  "Du paiement du client à votre caisse Business":
    "From the customer’s payment to your Business account",
  "Un parcours simple, sécurisé et traçable, depuis l’identification du payeur jusqu’au reversement des fonds dans le compte de votre organisation.":
    "A simple, secure and traceable journey, from identifying the payer to transferring the funds into your organization’s account.",
  "WonyaPay centralise l’identification, le paiement, la confirmation, le suivi et le reversement dans un même processus.":
    "WonyaPay brings identification, payment, confirmation, tracking and settlement together in one process.",
  "Étape 1": "Step 1",
  "Étape 2": "Step 2",
  "Étape 3": "Step 3",
  "Étape 4": "Step 4",
  "Étape 5": "Step 5",
  "Étape 6": "Step 6",
  Identification: "Identification",
  Consultation: "Review",
  "Choix du canal": "Payment channel",
  Confirmation: "Confirmation",
  "Collecte configurée": "Configured collection",
  "Compte partenaire": "Partner account",
  "Un parcours simple et traçable, depuis le choix du moyen de paiement jusqu’à la confirmation dans votre caisse.":
    "A simple and traceable journey, from choosing a payment method to confirmation in your cash register.",
  "Le client s’identifie": "The customer identifies themselves",
  "Le client scanne son QR Code WonyaPay ou sélectionne la facture qu’il souhaite régler.":
    "The customer scans their WonyaPay QR code or selects the invoice they want to pay.",
  "Identification du payeur": "Payer identification",
  "Accès sécurisé à son profil": "Secure access to their profile",
  "Récupération des factures associées": "Retrieval of associated invoices",
  "WonyaPay affiche les opérations disponibles":
    "WonyaPay displays the available transactions",
  "L’application affiche les factures à payer, les paiements déjà effectués et les informations utiles au règlement.":
    "The application displays invoices awaiting payment, completed payments and the information needed to proceed.",
  "Factures en attente": "Pending invoices",
  "Paiements déjà réalisés": "Completed payments",
  "Détails et historique du payeur": "Payer details and history",
  "Le client choisit son moyen de paiement":
    "The customer selects a payment method",
  "Le client sélectionne l’un des moyens de paiement disponibles et confirme la transaction.":
    "The customer selects one of the available payment methods and confirms the transaction.",
  "Carte bancaire": "Bank card",
  "Autres canaux activés pour le service":
    "Other channels enabled for the service",
  "WonyaPay traite et sécurise la transaction":
    "WonyaPay processes and secures the transaction",
  "La demande est transmise au canal sélectionné, vérifiée puis confirmée en temps réel selon la disponibilité du canal de paiement.":
    "The request is sent to the selected channel, verified and then confirmed in real time depending on the availability of the payment channel.",
  "Transmission sécurisée": "Secure transmission",
  "Vérification du statut": "Status verification",
  "Référence de transaction": "Transaction reference",
  "Le paiement est enregistré dans le circuit de collecte":
    "The payment is recorded in the collection flow",
  "Après confirmation, l’opération est enregistrée, la facture est mise à jour et les fonds suivent le circuit de collecte configuré pour le service.":
    "After confirmation, the transaction is recorded, the invoice is updated and the funds follow the collection flow configured for the service.",
  "Mise à jour de la facture": "Invoice update",
  "Traçabilité de l’opération": "Transaction traceability",
  "Préparation du reversement": "Settlement preparation",
  "Les fonds sont reversés sur le compte Mobile Money ou bancaire de votre organisation":
    "The funds are transferred to your organization’s Mobile Money or bank account",
  "WonyaPay communique avec les systèmes partenaires afin d’ordonner le reversement vers le compte Mobile Money ou le compte bancaire configuré par votre organisation.":
    "WonyaPay communicates with partner systems to initiate the transfer to the Mobile Money or bank account configured by your organization.",
  "Déclenchement du reversement": "Settlement initiation",
  "Rapprochement avec la transaction d’origine":
    "Reconciliation with the original transaction",
  "Historique disponible dans la caisse Business":
    "History available in the Business account",
  "Le délai effectif de crédit dépend du canal, de la configuration du service et de la disponibilité des systèmes partenaires.":
    "The actual crediting time depends on the channel, the service configuration and the availability of partner systems.",
  "Moyen de paiement": "Payment method",
  "Circuit de collecte": "Collection flow",
  Reversement: "Settlement",
  "Caisse Business": "Business account",
  "WonyaPay orchestre et trace le paiement, mais ne conserve pas définitivement les fonds de votre organisation. Après confirmation, les fonds suivent le circuit de collecte et de reversement configuré vers le compte Mobile Money ou le compte bancaire de votre entreprise, institution, école, commerce ou service.":
    "WonyaPay orchestrates and tracks the payment but does not permanently hold your organization’s funds. After confirmation, the funds follow the configured collection and settlement flow to the Mobile Money or bank account of your business, institution, school, shop or service.",
  "Traçabilité de chaque opération": "Traceability for every transaction",
  "Rapprochement avec la facture concernée":
    "Reconciliation with the relevant invoice",
  "Aperçu de la caisse Business": "Business account preview",
  "Opération après reversement": "Transaction after settlement",
  "Paiement confirmé": "Payment confirmed",
  "Facture mise à jour": "Invoice updated",
  "Référence : TX-••••••": "Reference: TX-••••••",
  "Canal de paiement": "Payment channel",
  "Statut du reversement": "Settlement status",
  "Historique disponible": "History available",
  "Garanties du parcours de paiement": "Payment journey safeguards",
  "Transaction sécurisée": "Secure transaction",
  "Suivi du statut": "Status tracking",
  "Traçabilité complète": "Complete traceability",
  "Reversement vers le compte du partenaire":
    "Settlement to the partner account",
  "Il scanne votre QR Code ou sélectionne la facture qu’il souhaite régler.":
    "They scan your QR code or select the invoice they want to pay.",
  "Il choisit son moyen de paiement": "They choose their payment method",
  "Le client confirme le paiement avec l’un des moyens disponibles.":
    "The customer confirms the payment using one of the available methods.",
  "WonyaPay sécurise la transaction": "WonyaPay secures the transaction",
  "La transaction est transmise, vérifiée et confirmée en temps réel.":
    "The transaction is transmitted, verified, and confirmed in real time.",
  "Votre caisse Business est créditée":
    "Your Business cash register is credited",
  "Le paiement apparaît dans votre caisse avec son statut et son historique.":
    "The payment appears in your cash register with its status and history.",
  "Votre argent reste destiné à votre activité":
    "Your money remains dedicated to your business",
  "WonyaPay orchestre et trace le paiement, mais ne conserve pas votre argent. Les fonds suivent le circuit de règlement configuré et sont crédités dans votre caisse Business.":
    "WonyaPay orchestrates and tracks the payment but does not hold your money. The funds follow the configured settlement flow and are credited to your Business cash register.",
  "Nos solutions": "Our solutions",
  "Tous droits réservés.": "All rights reserved.",
  "Termes et conditions": "Terms and conditions",
  "Politique de confidentialité": "Privacy policy",
  Conformité: "Compliance",
  "Contactez-nous": "Contact us",
  "Projet Développeur | API WonyaPay": "Developer Project | WonyaPay API",
  "Une API unifiée pour intégrer les paiements Mobile Money dans vos applications web, mobiles et métiers.":
    "A unified API for integrating Mobile Money payments into your web, mobile and business applications.",
  "Intégration de plusieurs moyens de paiement":
    "Multiple payment method integration",
  "Environnement de test et documentation API":
    "Test environment and API documentation",
  "Assistance pendant l’intégration": "Integration assistance",
  "Démarrer l’intégration": "Start integrating",
  "Paiement en Masse | BulkPay": "Bulk Payments | BulkPay",
  "Une solution conçue pour préparer, exécuter et suivre des paiements groupés avec plus de simplicité.":
    "A solution designed to prepare, execute and track bulk payments more easily.",
  "Importation des bénéficiaires": "Beneficiary import",
  "Suivi et rapports de paiement": "Payment tracking and reports",
  "Paiement de salaires, primes et fournisseurs":
    "Salary, bonus and supplier payments",
  "Demander une démonstration": "Request a demo",
  "Application mobile WonyaPay": "WonyaPay Mobile Application",
  "Une application simple et sécurisée permettant de payer, d’encaisser et de suivre ses opérations depuis un smartphone.":
    "A simple and secure application for making payments, collecting funds and tracking transactions from a smartphone.",
  "Paiement via les services Mobile Money disponibles":
    "Payments through available Mobile Money services",
  "Paiement et identification rapide par QR Code":
    "Fast QR Code payment and identification",
  "Consultation des transactions et des reçus":
    "Access to transactions and receipts",
  "Découvrir l’application": "Discover the application",
  "Des plateformes, logiciels et intégrations conçus selon vos besoins opérationnels et réglementaires.":
    "Platforms, software and integrations designed around your operational and regulatory needs.",
  "Analyse et conception fonctionnelle":
    "Business analysis and functional design",
  "Développement, intégration et mise en production":
    "Development, integration and go-live",
  "Maintenance et accompagnement technique":
    "Maintenance and technical support",
  "Demander un devis": "Request a quote",
  "Selon le volume des transactions": "Based on transaction volume",
  "Selon le nombre de paiements": "Based on the number of payments",
  "Accès à l’application": "Application access",
  "Sur devis": "On request",
  "Nos solutions numériques de paiement": "Our digital payment solutions",
  "Quatre offres complémentaires pour intégrer, payer en masse, encaisser sur mobile ou construire une plateforme dédiée.":
    "Four complementary offers to integrate payments, pay in bulk, collect on mobile or build a dedicated platform.",
  "Trois offres complémentaires pour intégrer, payer en masse ou encaisser sur mobile.":
    "Three complementary offers to integrate payments, make bulk payments or collect on mobile.",
  "Entreprise technologique congolaise": "Congolese technology company",
  "Les paiements numériques,": "Digital payments",
  "conçus pour vos réalités": "designed for your reality",
  "Les paiements numériques, conçus pour vos réalités":
    "Digital payments designed for your reality",
  "WonyaSoft développe des solutions numériques de paiement adaptées aux entreprises, institutions, établissements scolaires, marchands et développeurs. Grâce à WonyaPay, nos partenaires peuvent intégrer les principaux moyens de paiement, effectuer des paiements en masse, encaisser depuis une application mobile et déployer des solutions monétiques adaptées à leurs activités.":
    "WonyaSoft develops digital payment solutions for companies, institutions, schools, merchants and developers. With WonyaPay, our partners can integrate leading payment methods, make bulk payments, collect from a mobile application and deploy payment solutions tailored to their operations.",
  "Explorer nos solutions": "Explore our solutions",
  "Découvrir l’application WonyaPay": "Discover the WonyaPay application",
  "Agrément Banque Centrale du Congo": "Central Bank of Congo approval",
  "Paiements et agrégation Mobile Money":
    "Payments and Mobile Money aggregation",
  "Applications, API et solutions sur mesure":
    "Applications, APIs and custom solutions",
  "Un écosystème, quatre façons d’avancer":
    "One ecosystem, four ways to move forward",
  "Un écosystème, trois façons d’avancer":
    "One ecosystem, three ways to move forward",
  "Un écosystème, deux façons d’avancer":
    "One ecosystem, two ways to move forward",
  "Trois façons d’avancer avec WonyaSoft": "Three ways forward with WonyaSoft",
  "Deux façons d’avancer avec WonyaSoft": "Two ways forward with WonyaSoft",
  "API, paiements en masse ou encaissement mobile : WonyaSoft réunit les briques nécessaires pour déployer des services de paiement fiables en RDC.":
    "API, bulk payments, or mobile collection: WonyaSoft brings together the building blocks needed to deploy reliable payment services in the DRC.",
  "De l’intégration API à l’encaissement mobile, choisissez le parcours adapté à votre organisation.":
    "From API integration to mobile collection, choose the path that fits your organization.",
  "Une orchestration claire de vos opérations":
    "Clear orchestration of your operations",
  Intégrer: "Integrate",
  "Une API de paiement pensée pour les produits numériques et les systèmes métiers.":
    "A payment API designed for digital products and business systems.",
  Décaisser: "Disburse",
  "BulkPay simplifie les paiements groupés et leur suivi opérationnel.":
    "BulkPay simplifies bulk payments and operational tracking.",
  Encaisser: "Collect",
  "L’application WonyaPay accompagne les opérations directement sur smartphone.":
    "The WonyaPay application supports operations directly from a smartphone.",
  Adapter: "Customize",
  "Nos équipes conçoivent les plateformes et intégrations propres à votre activité.":
    "Our teams design platforms and integrations tailored to your business.",
  "Des solutions adaptées à chaque organisation":
    "Solutions for every organization",
  "Entreprises et marchands": "Companies and merchants",
  "Écoles et universités": "Schools and universities",
  "Institutions et services publics": "Institutions and public services",
  "Développeurs et éditeurs": "Developers and software publishers",
  "Un cadre de confiance pour vos paiements":
    "A trusted framework for your payments",
  "WonyaSoft accorde une attention particulière à la sécurité, à la fiabilité, à la conformité et à l’accompagnement technique de chaque partenaire.":
    "WonyaSoft places particular emphasis on security, reliability, compliance and technical support for every partner.",
  "En savoir plus sur notre conformité": "Learn more about our compliance",
  "Construisons votre prochain parcours de paiement":
    "Let’s build your next payment journey",
  "Notre équipe vous accompagne du cadrage jusqu’à l’intégration et la mise en production.":
    "Our team supports you from scoping through integration and go-live.",
  "Voir WonyaPay": "View WonyaPay",
  "Offres et tarification": "Offers and pricing",
  "L’accès à l’API WonyaPay est proposé à 50 USD, avec une commission de 3 % par transaction. Les autres offres sont adaptées au volume et au périmètre de votre organisation.":
    "WonyaPay API access is available for USD 50, with a 3% commission per transaction. Other offers are tailored to your organization’s volume and scope.",
  "50 USD + 3 % de commission par transaction":
    "USD 50 + 3% commission per transaction",
  "2 à 5 % par transaction selon le volume":
    "2% to 5% per transaction depending on volume",
  "Frais d’intégration": "Integration fee",
  "Commission par transaction": "Commission per transaction",
  "Accès gratuit": "Free access",
  "Pour les organisations": "For organizations",
  "Solutions monétiques sur mesure": "Custom payment solutions",
  "Pour les entreprises et institutions": "For businesses and institutions",
  "Concevons une plateforme, un logiciel ou une intégration adaptée à vos processus opérationnels et réglementaires.":
    "Let us design a platform, software product, or integration tailored to your operational and regulatory processes.",
  "Analyse fonctionnelle et cadrage du projet":
    "Functional analysis and project scoping",
  "Conception adaptée à vos équipes et à vos flux":
    "A design tailored to your teams and workflows",
  "Intégration, déploiement et accompagnement":
    "Integration, deployment, and support",
  "Maintenance et évolution de la solution":
    "Solution maintenance and evolution",
  "Parler de votre projet": "Discuss your project",
  "Les frais d’intégration de l’API WonyaPay sont de 50 USD, avec une commission de 3 % par transaction. L’accès à l’application mobile WonyaPay est gratuit.":
    "The WonyaPay API integration fee is USD 50, with a 3% commission per transaction. Access to the WonyaPay mobile application is free.",
  "Des offres lisibles, adaptées à votre usage":
    "Clear offers tailored to your use case",
  "Les conditions exactes dépendent du volume, du périmètre et des besoins de votre organisation. Aucun montant non validé n’est affiché.":
    "Exact terms depend on your volume, scope and organization needs. No unverified amount is displayed.",
  Tarification: "Pricing",
  "Ce qui est inclus": "What is included",
  "Une tarification transparente, sans hypothèse":
    "Transparent pricing, without assumptions",
  "Chaque proposition est établie à partir de votre flux réel, de vos volumes, des opérateurs concernés et du niveau d’accompagnement attendu.":
    "Each proposal is based on your actual flow, volumes, operators involved and expected support level.",
  "Décrivez votre besoin": "Describe your need",
  "Nous identifions le bon parcours": "We identify the right path",
  "Vous recevez une proposition adaptée": "You receive a tailored proposal",
  "Parler à notre équipe": "Talk to our team",
  "À propos de WonyaSoft": "About WonyaSoft",
  "La technologie congolaise au service des paiements":
    "Congolese technology serving payments",
  "WonyaSoft est une entreprise technologique congolaise spécialisée dans le développement de solutions numériques de paiement, l’édition de logiciels et la conception de plateformes monétiques adaptées aux réalités du marché congolais.":
    "WonyaSoft is a Congolese technology company specializing in digital payment solutions, software publishing and payment platforms designed for the realities of the Congolese market.",
  "Qui sommes-nous ?": "Who are we?",
  "WonyaSoft accompagne les entreprises, institutions, établissements scolaires, marchands et développeurs dans leur transformation numérique. À travers sa plateforme WonyaPay, l’entreprise facilite l’intégration des paiements Mobile Money, les paiements en masse, l’encaissement mobile et le développement de solutions de paiement sur mesure.":
    "WonyaSoft supports companies, institutions, schools, merchants and developers through their digital transformation. Through its WonyaPay platform, the company facilitates Mobile Money payment integration, bulk payments, mobile collection and custom payment solution development.",
  "WonyaSoft est agréée par la Banque Centrale du Congo en qualité d’agrégateur, d’éditeur de logiciels et de fournisseur de solutions monétiques.":
    "WonyaSoft is approved by the Central Bank of Congo as an aggregator, software publisher and payment solution provider.",
  "Notre mission": "Our mission",
  "Notre mission est de rendre les paiements numériques plus simples, accessibles, sécurisés et adaptés aux besoins des organisations congolaises.":
    "Our mission is to make digital payments simpler, more accessible, secure and suited to the needs of Congolese organizations.",
  "Nos principales solutions": "Our main solutions",
  "Notre engagement": "Our commitment",
  "Nous accordons une importance particulière à la sécurité, à la fiabilité, à la conformité, à la disponibilité des services et à la qualité de l’accompagnement technique fourni à nos partenaires.":
    "We place particular importance on security, reliability, compliance, service availability and the quality of technical support provided to our partners.",
  "Construisons votre prochaine solution de paiement":
    "Let’s build your next payment solution",
  "Notre équipe vous accompagne depuis l’analyse de votre besoin jusqu’à l’intégration et la mise en production.":
    "Our team supports you from needs analysis through integration and go-live.",
  "Nous contacter": "Contact us",
  "Découvrir WonyaPay": "Discover WonyaPay",
  "Application de paiement mobile": "Mobile payment application",
  "Vos paiements dans une seule application":
    "Your payments in one application",
  "Avec l’application mobile WonyaPay, payez, encaissez et suivez vos opérations simplement depuis votre smartphone.":
    "With the WonyaPay mobile application, make payments, collect funds and track your operations easily from your smartphone.",
  "Accéder à WonyaPay": "Access WonyaPay",
  "Contacter notre équipe": "Contact our team",
  "Inscrire votre business": "Register your business",
  "Fermer le formulaire d’inscription": "Close the registration form",
  "Télécharger l’application mobile": "Download the mobile app",
  "Téléchargez WonyaPay sur votre smartphone.":
    "Download WonyaPay on your smartphone.",
  "Une expérience mobile pensée pour le quotidien":
    "A mobile experience designed for everyday use",
  "WonyaPay réunit les opérations essentielles dans une interface simple, adaptée aux particuliers comme aux organisations.":
    "WonyaPay brings essential operations together in a simple interface designed for both individuals and organizations.",
  "Paiements Mobile Money": "Mobile Money payments",
  "Utilisez les services Mobile Money disponibles dans un parcours unifié.":
    "Use available Mobile Money services in one unified journey.",
  "Encaissement mobile": "Mobile collection",
  "Recevez et suivez les paiements directement depuis votre smartphone.":
    "Receive and track payments directly from your smartphone.",
  "QR Code": "QR Code",
  "Payez ou identifiez une opération rapidement grâce au scan.":
    "Pay or identify an operation quickly by scanning.",
  "Historique et suivi": "History and tracking",
  "Consultez les transactions, leur statut et les reçus de paiement.":
    "View transactions, their status and payment receipts.",
  "Pour qui est conçue WonyaPay ?": "Who is WonyaPay for?",
  Particuliers: "Individuals",
  Marchands: "Merchants",
  Entreprises: "Companies",
  Institutions: "Institutions",
  "Services publics": "Public services",
  "Organisations et projets": "Organizations and projects",
  "Des opérations simples et sécurisées": "Simple and secure operations",
  "La sécurité, la traçabilité et la clarté des statuts sont intégrées au parcours afin que chaque utilisateur garde une lecture précise de ses opérations.":
    "Security, traceability and clear statuses are built into the journey so every user can maintain a precise view of their operations.",
  "Télécharger pour Android": "Download for Android",
  "Télécharger pour iPhone": "Download for iPhone",
  "Déjà disponibles dans le projet": "Already available in the project",
  "WonyaSoft | Solutions numériques de paiement en RDC":
    "WonyaSoft | Digital payment solutions in the DRC",
  "Solutions de paiement | WonyaSoft": "Payment solutions | WonyaSoft",
  "Découvrez WonyaPay, l’API de paiement, BulkPay, l’application mobile et les solutions monétiques sur mesure développées par WonyaSoft.":
    "Discover WonyaPay, the payment API, BulkPay, the mobile application and custom payment solutions developed by WonyaSoft.",
  "Offres et tarifs | WonyaSoft": "Offers and pricing | WonyaSoft",
  "Découvrez les offres WonyaSoft pour l’intégration de paiements, le paiement en masse, l’encaissement mobile et le développement de solutions monétiques.":
    "Discover WonyaSoft offers for payment integration, bulk payments, mobile collection and custom payment solution development.",
  "WonyaSoft est une entreprise technologique congolaise spécialisée dans les paiements numériques, les logiciels et les solutions monétiques.":
    "WonyaSoft is a Congolese technology company specializing in digital payments, software and payment solutions.",
  "Application mobile WonyaPay | WonyaSoft":
    "WonyaPay Mobile Application | WonyaSoft",
  "Payez, encaissez, scannez des QR Codes et suivez vos opérations avec l’application mobile WonyaPay.":
    "Make payments, collect funds, scan QR Codes and track your operations with the WonyaPay mobile application.",
  "Équipe WonyaSoft au travail": "WonyaSoft team at work",
  "Utilisatrice de l’application mobile WonyaPay":
    "WonyaPay mobile application user",
  Sécurité: "Security",
  Fiabilité: "Reliability",
  "Accompagnement technique": "Technical support",
  "Logo de l’application WonyaPay": "WonyaPay application logo",
  "WonyaSoft — Accueil": "WonyaSoft — Home",
  "Aller au contenu principal": "Skip to main content",
  "WonyaSoft développe WonyaPay, BulkPay, une application mobile de paiement, des API de paiement et des solutions monétiques adaptées aux entreprises et institutions.":
    "WonyaSoft develops WonyaPay, BulkPay, a mobile payment application, payment APIs and payment solutions tailored to businesses and institutions.",
  "WonyaSoft conçoit WonyaPay, BulkPay, des API de paiement et des solutions monétiques adaptées aux entreprises et institutions en RDC.":
    "WonyaSoft builds WonyaPay, BulkPay, payment APIs and payment solutions tailored to businesses and institutions in the DRC.",
  "Écosystème WonyaPay : application mobile, API et paiements en masse":
    "WonyaPay ecosystem: mobile application, API and bulk payments",
  "WonyaPay actif": "WonyaPay active",
  "Transaction réussie": "Successful transaction",
  "API connectée": "API connected",
  "Paiement Mobile Money": "Mobile Money payment",
  "QR Code vérifié": "Verified QR Code",
  "Nos engagements de confiance": "Our trust commitments",
  "Agrégation Mobile Money": "Mobile Money aggregation",
  "API de paiement": "Payment API",
  "Assistance à l’intégration": "Integration support",
  "Paiements sécurisés": "Secure payments",
  "Ils nous font confiance": "They trust us",
  "Organisations qui nous font confiance": "Organizations that trust us",
  "Un parcours simple": "A simple journey",
  "Comment fonctionne l’écosystème WonyaSoft ?":
    "How does the WonyaSoft ecosystem work?",
  "Trois étapes structurées pour passer du besoin à des opérations suivies au quotidien.":
    "Three structured steps from your needs to daily monitored operations.",
  "Choisissez votre solution": "Choose your solution",
  "Sélectionnez l’API WonyaPay, BulkPay, l’application mobile ou une solution développée sur mesure.":
    "Select the WonyaPay API, BulkPay, the mobile application or a custom-built solution.",
  "Intégrez ou configurez": "Integrate or configure",
  "Notre équipe vous accompagne dans la configuration, les tests et la mise en service.":
    "Our team supports you through configuration, testing and go-live.",
  "Payez, encaissez et suivez": "Pay, collect and track",
  "Gérez vos opérations depuis une interface claire, sécurisée et adaptée à votre activité.":
    "Manage your operations from a clear, secure interface tailored to your business.",
  "Pour chaque organisation": "For every organization",
  "Des solutions pensées pour vos usages": "Solutions designed for your needs",
  "WonyaSoft adapte ses parcours aux réalités opérationnelles de plusieurs secteurs.":
    "WonyaSoft adapts its payment journeys to the operational realities of multiple sectors.",
  "Encaissement et paiements fournisseurs": "Collection and supplier payments",
  "Paiements de bénéficiaires et suivi": "Beneficiary payments and tracking",
  "Paiement des frais scolaires": "School fee payments",
  Développeurs: "Developers",
  "Intégration API": "API integration",
  "Paiements en masse": "Bulk payments",
  "Parcours de paiement adaptés": "Tailored payment journeys",
  "Sécurité et conformité": "Security and compliance",
  "Des paiements conçus pour inspirer confiance":
    "Payments designed to inspire trust",
  "WonyaSoft accorde une attention particulière à la sécurité, à la traçabilité, au contrôle des accès et à la conformité avec les exigences applicables.":
    "WonyaSoft pays particular attention to security, traceability, access control and compliance with applicable requirements.",
  "Sécurité des transactions": "Transaction security",
  "Des parcours conçus pour protéger les opérations et leurs statuts.":
    "Journeys designed to protect operations and their statuses.",
  "Traçabilité des opérations": "Transaction traceability",
  "Un suivi clair des événements importants tout au long du paiement.":
    "Clear tracking of important events throughout the payment process.",
  "Contrôle des accès": "Access control",
  "Des accès structurés selon les rôles et les besoins opérationnels.":
    "Access structured by roles and operational needs.",
  "Intégrations protégées": "Protected integrations",
  "Des échanges sécurisés et un accompagnement technique à l’intégration.":
    "Secure exchanges and technical support throughout integration.",
  "Prêt à moderniser vos paiements ?": "Ready to modernize your payments?",
  "Intégrez WonyaPay, lancez vos paiements en masse ou développez une solution adaptée à votre organisation.":
    "Integrate WonyaPay, launch bulk payments, or develop a solution tailored to your organization.",
  "Démarrez votre demande d’inscription": "Start your registration request",
  "Un parcours guidé et sécurisé pour les écoles, les marchands et les prestataires de services, indépendant du formulaire de contact général.":
    "A guided and secure journey for schools, merchants and service providers, separate from the general contact form.",
  Profil: "Profile",
  Organisation: "Organization",
  Projet: "Project",
  Vérification: "Review",
  "Progression de la demande": "Request progress",
  Étape: "Step",
  "Quel profil souhaitez-vous inscrire?":
    "Which profile would you like to register?",
  "Quel profil souhaitez-vous inscrire ?":
    "Which profile would you like to register?",
  "Votre choix adapte les prochaines questions à votre activité.":
    "Your choice tailors the next questions to your activity.",
  "Une école": "A school",
  "Établissement scolaire, institut ou université":
    "School, college or university",
  "Un marchand": "A merchant",
  "Commerce, boutique ou point de vente": "Business, shop or point of sale",
  "Un prestataire de services": "A service provider",
  "Abonnement, cotisation, forfait ou prestation ponctuelle":
    "Subscription, membership, package or one-time service",
  "Ce champ est requis.": "This field is required.",
  "Saisissez une adresse email valide.": "Enter a valid email address.",
  "Parlez-nous de votre établissement": "Tell us about your institution",
  "Parlez-nous de votre commerce": "Tell us about your business",
  "Parlez-nous de vos services": "Tell us about your services",
  "Ces informations nous permettent de qualifier votre demande.":
    "This information helps us assess your request.",
  "Nom de l’établissement": "Institution name",
  "Nom du commerce": "Business name",
  "Nom de l’entreprise ou de l’activité": "Company or business name",
  "Nom du responsable": "Contact person",
  Ville: "City",
  Province: "Province",
  "Type d’établissement": "Institution type",
  Sélectionnez: "Select",
  "École primaire ou secondaire": "Primary or secondary school",
  "Institut supérieur ou université": "College or university",
  "Centre de formation": "Training center",
  "Nombre approximatif d’élèves ou étudiants":
    "Approximate number of pupils or students",
  "Secteur d’activité": "Business sector",
  "Ex. alimentation, pharmacie, services": "E.g. grocery, pharmacy, services",
  "Nombre de points de vente": "Number of points of sale",
  "Type de services": "Type of services",
  "Services professionnels ou conseil": "Professional services or consulting",
  "Santé, beauté ou bien-être": "Health, beauty or wellness",
  "Transport ou logistique": "Transport or logistics",
  "Immobilier ou location": "Real estate or rental",
  "Association, club ou organisation": "Association, club or organization",
  "Services numériques ou contenus": "Digital services or content",
  "Autre activité de services": "Other service activity",
  "Mode de facturation principal": "Main billing model",
  "Mode de facturation": "Billing model",
  "Abonnement récurrent": "Recurring subscription",
  "Paiement par prestation": "Pay per service",
  "Forfait ou paiement anticipé": "Package or prepaid payment",
  "Cotisation ou adhésion": "Membership fee",
  "Modèle mixte": "Mixed model",
  "Nombre approximatif de clients ou abonnés":
    "Approximate number of customers or subscribers",
  "Quel est votre besoin principal ?": "What is your main need?",
  "Précisez votre objectif afin que notre équipe prépare le bon accompagnement.":
    "Clarify your goal so our team can prepare the right support.",
  "Solution recherchée": "Solution required",
  "Suivi des paiements": "Payment tracking",
  "Solution complète pour établissement": "Complete institution solution",
  "Encaissement Mobile Money": "Mobile Money collection",
  "Paiement par QR Code": "QR Code payment",
  "Gestion de plusieurs points de vente": "Multiple point-of-sale management",
  "Encaissement des abonnements ou cotisations":
    "Subscription or membership fee collection",
  "Facturation et rappels de paiement": "Billing and payment reminders",
  "Paiement de prestations par lien ou QR Code":
    "Service payment by link or QR Code",
  "Suivi des clients et des échéances": "Customer and due-date tracking",
  "Autre besoin": "Other need",
  "Délai envisagé": "Expected timeline",
  "Dès que possible": "As soon as possible",
  "Dans un à trois mois": "Within one to three months",
  "Plus tard ou à définir": "Later or to be determined",
  "Informations complémentaires": "Additional information",
  "Décrivez brièvement votre fonctionnement actuel et le résultat attendu.":
    "Briefly describe your current operation and the expected outcome.",
  "N’incluez jamais de mot de passe, de code PIN ou de secret API.":
    "Never include a password, PIN or API secret.",
  "Vérifiez votre demande": "Review your request",
  "Relisez les informations avant l’envoi à l’équipe WonyaSoft.":
    "Review the information before sending it to the WonyaSoft team.",
  École: "School",
  Marchand: "Merchant",
  "Prestataire de services": "Service provider",
  Responsable: "Contact person",
  Coordonnées: "Contact details",
  Localisation: "Location",
  Besoin: "Requirement",
  Délai: "Timeline",
  "J’accepte que WonyaSoft utilise ces informations uniquement pour traiter cette demande et me recontacter.":
    "I agree that WonyaSoft may use this information only to process this request and contact me.",
  Retour: "Back",
  Continuer: "Continue",
  "Envoyer la demande d’inscription": "Send registration request",
  "L’envoi a échoué. Vérifiez votre connexion puis réessayez, ou contactez-nous par WhatsApp.":
    "Sending failed. Check your connection and try again, or contact us on WhatsApp.",
  "Demande transmise": "Request sent",
  "Votre demande d’inscription a bien été envoyée.":
    "Your registration request has been sent.",
  "Notre équipe examinera les informations et vous contactera pour la prochaine étape.":
    "Our team will review the information and contact you about the next step.",
  "Envoyer une autre demande": "Send another request",
  "Un parcours rapide pour transmettre un brief clair à notre équipe.":
    "A quick guided journey to send our team a clear brief.",
  "Intégration et API": "Integration and API",
  "API Mobile Money, documentation et accompagnement technique":
    "Mobile Money API, documentation and technical support",
  "Paiements et solutions": "Payments and solutions",
  "BulkPay, encaissement, application ou solution monétique":
    "BulkPay, collection, application or payment solution",
  "Projet et accompagnement": "Project and support",
  "Développement sur mesure, partenariat ou besoin spécifique":
    "Custom development, partnership or specific requirement",
  "Quel projet souhaitez-vous lancer ?":
    "What project would you like to launch?",
  "Sélectionnez la famille qui correspond le mieux à votre demande.":
    "Select the category that best matches your request.",
  "Quel est le motif de votre demande ?":
    "What is the reason for your request?",
  "Choisissez l’une des options ci-dessous pour nous indiquer comment nous pouvons vous aider.":
    "Choose one of the options below to tell us how we can help you.",
  "Comment pouvons-nous vous recontacter ?": "How can we contact you?",
  "Indiquez les coordonnées de la personne qui suit le projet.":
    "Provide the contact details of the person managing the project.",
  "Entreprise ou institution": "Company or institution",
  "Donnez-nous le contexte essentiel": "Give us the essential context",
  "Quelques informations précises suffisent pour préparer le premier échange.":
    "A few precise details are enough to prepare the first discussion.",
  "Documentation ou assistance API": "API documentation or assistance",
  "Encaissement et paiement numérique": "Collection and digital payments",
  "Autre projet": "Other project",
  "Relisez votre brief avant son envoi à l’équipe WonyaSoft.":
    "Review your brief before sending it to the WonyaSoft team.",
  Brief: "Brief",
  "Votre demande de projet a bien été envoyée.":
    "Your project request has been sent.",
  "Notre équipe examinera votre brief et vous contactera pour organiser la prochaine étape.":
    "Our team will review your brief and contact you to arrange the next step.",
  "WonyaSoft Business | Inscription école, marchand et prestataire":
    "WonyaSoft Business | School, merchant and service provider registration",
  "Inscrivez votre école, commerce ou activité de services et présentez vos besoins de paiement à l’équipe WonyaSoft.":
    "Register your school, business or service activity and tell the WonyaSoft team about your payment needs.",
  "Des paiements mieux adaptés à votre activité":
    "Payments better suited to your business",
  "École, commerce ou activité de services : présentez votre organisation et préparez avec WonyaSoft un parcours de paiement adapté à votre fonctionnement.":
    "School, shop or service activity: introduce your organization and prepare a payment journey tailored to how you operate with WonyaSoft.",
  "Commencer l’inscription": "Start registration",
  "Points clés du parcours Business": "Key points of the Business journey",
  "Questions adaptées au profil": "Profile-specific questions",
  "Vérification avant envoi": "Review before sending",
  "Profils accompagnés": "Supported profiles",
  "Choisissez votre profil": "Choose your profile",
  "Écoles et établissements": "Schools and institutions",
  "Structurez votre demande autour du paiement et du suivi des frais scolaires.":
    "Structure your request around school-fee payment and tracking.",
  "Marchands et commerces": "Merchants and businesses",
  "Présentez votre activité, vos points de vente et vos besoins d’encaissement.":
    "Introduce your business, points of sale and collection needs.",
  "Prestataires de services": "Service providers",
  "Décrivez vos abonnements, cotisations, forfaits ou paiements par prestation.":
    "Describe your subscriptions, memberships, packages or service payments.",
  "Inscription Business": "Business registration",
  "Présentez votre activité en quelques étapes":
    "Introduce your business in a few steps",
  "Sélectionnez votre profil, complétez les informations utiles puis vérifiez la demande avant son envoi.":
    "Select your profile, provide the relevant information, then review the request before sending it.",
  "Pourquoi ce parcours ?": "Why this journey?",
  "Une demande claire dès le départ": "A clear request from the start",
  "Une demande adaptée à votre profil": "A request tailored to your profile",
  "Les questions évoluent selon votre activité pour recueillir uniquement les informations pertinentes.":
    "The questions adapt to your activity to collect only the relevant information.",
  "Un parcours clair et sécurisé": "A clear and secure journey",
  "Vous vérifiez toutes les informations avant leur transmission à l’équipe WonyaSoft.":
    "You review all information before it is sent to the WonyaSoft team.",
  "Une prochaine étape mieux préparée": "A better-prepared next step",
  "Votre brief permet à notre équipe de comprendre le contexte avant de vous recontacter.":
    "Your brief helps our team understand the context before contacting you.",
  "Besoin d’aide avant de commencer ?": "Need help before you start?",
  "Notre équipe peut vous orienter": "Our team can guide you",
  "Utilisez la page Contact pour une question générale, une intégration API ou un projet sur mesure.":
    "Use the Contact page for a general question, API integration or custom project.",
  "Contacter WonyaSoft": "Contact WonyaSoft",
  "Intégrations Mobile Money": "Mobile Money integrations",
  "Les principaux réseaux, réunis dans une seule intégration":
    "Leading networks, brought together in one integration",
  "WonyaPay connecte vos parcours d’encaissement et de paiement aux réseaux Mobile Money disponibles en RDC.":
    "WonyaPay connects your collection and payment journeys to the Mobile Money networks available in the DRC.",
  "Réseaux Mobile Money intégrés à WonyaPay":
    "Mobile Money networks integrated with WonyaPay",
};

export default manualFrToEn;
